<ng-container *ngIf="getBookerData$ | async as bookerData; else showSkeleton">
  <dot-booker-air
    [content]="bookerData"
    [disableAutoSubmit]="disableAutoSubmit"
    [saveToUrlParam]="saveToUrlParam !== 'false' && saveToUrlParam"
    [tripType]="tripType"
    [isTrueBlue]="isTrueBlue !== 'false' && isTrueBlue"
    [destinationAirport]="destinationAirport"
    [originAirport]="originAirport"
    [departDate]="departDate"
    [returnDate]="returnDate"
    [travelerCountAdult]="travelerCountAdult | ensureNumber"
    [travelerCountChild]="travelerCountChild | ensureNumber"
    [travelerCountInfant]="travelerCountInfant | ensureNumber"
    [multiFlights]="multiFlights"
    [promoCode]="promoCode"
    (jbBookerSubmit)="jbBookerSubmit.emit($event)"
    class="jb-grid one-up grid-offset-l"
  >
  </dot-booker-air>
</ng-container>

<ng-template #showSkeleton>
  <dot-base-booker-skeleton
    class="jb-grid one-up grid-offset-l white-bg-skeleton"
  ></dot-base-booker-skeleton>
</ng-template>
